import Swiper, { Pagination } from 'swiper'

export default function() {
	Swiper.use([Pagination])
	let container = document.querySelector('.buy-options__slider')
	// if(window.matchMedia("(max-width: 1366px)").matches && container) {
		new Swiper(container.querySelector('.swiper-container'), {
			// Optional parameters
			loop: false,
			slidesPerView: 4,
			spaceBetween: 30,
			pagination: {
				el: container.querySelector('.swiper-pagination'),
				clickable: true,
			},
			breakpoints: {
				320: {
					slidesPerView: 1,
				},
				600: {
					slidesPerView: 2,
				},
				980: {
					slidesPerView: 3,
				},
				1366: {
					slidesPerView: 4,
				},
				onInit: function(swiper) { 
					if(swiper.slides.length <= 1) {
						// container.querySelector('.swiper-pagination').hidden = true;  
						swiper.disable()
					}
				}
			}
		})
	// }
}